export default __webpack_public_path__ + "static/media/Oldtabnav.e08d2e79.PNG";